import { html } from 'lit-element';

export const getIcon = (correct, asString) => {
  if (asString) {
    return correct ? '&#10004;' : '&#10006;';
  }

  return correct ? html`&#10004;` : html`&#10006;`;
};

export const getPart = (modelPart, sessionPart, mouseFunctions) => {
  const { choices, choicePrefix } = modelPart || {};
  const { value } = sessionPart || {};
  const { mouseover, mouseout } = mouseFunctions || {};

  if (!choices || !value) return '';

  const charCode = choicePrefix === 'numbers' ? 49 : 65;

  const valuesToRender = choices.reduce((acc, choice, index) => {
    if (value.indexOf(choice.value) >= 0) {
      acc.push(index);
    }

    return acc;
  }, []);

  return valuesToRender.map(index => {
    const { correct, label } = choices[index];

    return html`<div
      class="choice-value"
      @mouseover=${e => mouseover(e, label)}
      @mouseout=${mouseout}
    >
      <span>${String.fromCharCode(index + charCode)}</span>
      <span class="correctness-indicator">${getIcon(correct)}</span>
    </div>`;
  });
};

export const processEscapedMarkup = value => {
  // todo: check why
  // the markup arrives in this point processed (eg: with lt instead of <) so we have to recreate it
  const div = document.createElement('textarea');
  div.innerHTML = value;

  return div.innerText;
};

export const renderBubble = hoveredChoice => {
  if (!hoveredChoice || !hoveredChoice.value) return html``;

  return html` <div
    class="bubble"
    style="top: ${hoveredChoice.top}px; left: ${hoveredChoice.left}px;"
  >
    <math-rendering-element .label=${processEscapedMarkup(hoveredChoice.value)}>
    </math-rendering-element>
  </div>`;
};
